import React from "react";
import "./sass/style.scss";
import { AppRoutes } from "./Routes";
import CookieConsent from "./components/ui/CookieConsent/CookieConsent";

function App() {
  return (
    <div className="App">
      <AppRoutes />
      <CookieConsent />
    </div>
  );
}

export default App;